import * as types from './types';

export const selectLessonPlannerWorkbook = (
  workbook: string
): types.SELECT_LESSON_PLANNER_WORKBOOK_ACTION => ({
  type: types.SELECT_LESSON_PLANNER_WORKBOOK,
  workbook
});

export const selectLessonPlannerNavbarChange = (
  attribute: string,
  value: any
): types.SELECT_LESSON_PLANNER_NAVBAR_CHANGE_ACTION => ({
  type: types.SELECT_LESSON_PLANNER_NAVBAR_CHANGE,
  attribute,
  value
});

export const setLessonPlanCurrentWeek = (week: number) => ({
  type: types.SET_CURRENT_LESSON_PLAN_WEEK,
  data: week
});

export const setLessonPlanNumberOfWeeks = (numberOfWeeks: number) => ({
  type: types.SET_NUMBER_OF_WEEKS,
  data: numberOfWeeks
});

export const setLessonPlanDay = (currentDay) => ({
  type: types.SET_LESSON_PLAN_DAY,
  data: currentDay
})